import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import TradeKeyboard from '../Tradekeyboard/TradeKeyboard';
import * as conditionData from '@/views/condition/ConditionData';
import front from '@/../static/js/proto/CtpFront';
import { mapGetters } from 'vuex';
import * as ctpfront_pb from '@/../static/js/proto/CtpFront_pb';
import * as utils from '@/utils/utils';
import logList from './LogList/LogList';

// import model from "../../../static/js/proto/Model.js";

@Component({
  components: {
    TradeKeyboard,
    logList,
  },
  computed: {
    ...mapGetters({
      conditionNotTriggerList: 'Params/conditionNotTriggerList',
    }),
  },
})

export default class CheckFullStop extends Vue {
  @Prop()
  public datas: any;
  @Prop()
  public tids: any;
  @Prop()
  public titles: any;
  @Prop()
  public positions: any;
  @Prop()
  public showFlage: boolean;

  // 键盘数据
  @Prop()
  public tick: any;
  @Prop()
  public priceTicks: any;

  // 列表头部信息
  public listTitle: any[] = ['添加日期', '数量', '止损价', '止盈价', '状态', '有效期'];
  public touchFlage: boolean = false;
  // 列表数据
  public listData: any[] = [];
  public nums: number = -1;
  public popupFlage: boolean = true;
  // 键盘
  public priceFlage: boolean = false;
  public priceFlage2: boolean = false;
  // public numFlage: boolean = false;
  public numFlage2: boolean = false;
  // 止盈止损价格,数量
  public lossPrice: any = '';
  public profitPrice: any = '';
  // public profitNum: number = 0;
  public lossNum: number = 1;
  public period: string = '0';

  // public errorFlage: boolean = false;
  public errorMsg: string = '';
  public conditionNotTriggerList: IOrderConditional[];
  public itemData: any = '';
  public enterTxt: string = '添加';
  // 统计已有条件单手数
  public hasNum: any = 0;
  /**记录当前修改的合约手数 */
  public thisNum: any = 0;
  // 数据
  public ChectData: any = '';
  public newPrice: any = '';

  // 选择有效期
  public validity: any[] = ['当日', '永久'];
  public validityFlage: boolean = false;
  public showTxt: string = '当日';
  public showFeedbackToast: boolean = false;
  public feedbackMessage: string = '';
  public feedbackType: string = 'success';
  public feedbackTimer = null;
  public get runningCount() {
    return this.listData.filter(item => item.buttonTxt === '暂停').length;
  }
  public get pausedCount() {
    return this.listData.filter(item => item.buttonTxt === '启动').length;
  }
  // 点击列表
  public handleSelectList(item, index) {
    if (this.nums === index) {
      this.nums = -1;
      return;
    }
    this.nums = index;
  }
  /**列表滚动 */
  public handleMoveT() {
    if (!this.touchFlage) {
      (this.$refs.contentScroll as any).scrollLeft =
        (this.$refs.titleScroll as any).scrollLeft;
    }
  }
  public handleMoveC() {
    if (this.touchFlage) {
      (this.$refs.titleScroll as any).scrollLeft =
        (this.$refs.contentScroll as any).scrollLeft;
    }
  }
  public handletouchC() {
    this.touchFlage = false;
  }
  public handletouchT() {
    this.touchFlage = true;
  }

  public openFeedbackToast(message: string, type: string = 'success', duration: number = 2200) {
    this.feedbackMessage = message;
    this.feedbackType = type;
    this.showFeedbackToast = true;
    if (this.feedbackTimer) {
      clearTimeout(this.feedbackTimer);
    }
    this.feedbackTimer = setTimeout(() => {
      this.showFeedbackToast = false;
      this.feedbackTimer = null;
    }, duration);
  }
  public getCardStateText(item) {
    return item.buttonTxt === '暂停' ? '运行中' : '已暂停';
  }

  // 返回
  public handleGoBack() {
    front.unsubTick(this.tids, 'CheckFullStop');
    this.$emit('hiddenPage');
    utils.closeIndicator();
  }
  // 显示/关闭添加弹窗
  public handleClose(flage, data: any = '') {
    if (!flage) {
      if (data) {
        this.profitPrice = data.profitPrice;
        this.lossPrice = data.lossPrice;
        this.lossNum = data.num;
        this.period = data.validTime;
        this.showTxt = this.validity[this.period];
      } else {
        this.profitPrice = this.ChectData.latestPrice;
        this.lossPrice = this.ChectData.latestPrice;
        this.lossNum = 1;
        this.period = '0';
        this.showTxt = '当日';
      }
    } else {
      this.enterTxt = '增加条件单';
    }
    this.popupFlage = flage;
    this.validityFlage = false;
  }
  // 确认添加
  public handleEnterAdd() {
    if (this.enterTxt === '增加条件单') {
      this.addEdit();
    } else {
      this.addEdit(this.itemData);
      // this.hasNum = 0;
    }
    this.validityFlage = false;
  }
  public direction(type) {
    if (type === '买') {
      return 1;
    } else if (type === '卖') {
      return 2;
    }
  }

  // << 止损数量
  public handleNumCloseKey2() {
    (this.$refs.Lnums as any).blur();
    this.numFlage2 = false;
  }
  // << 止盈价钱
  public handleMoneyCloseKey1() {
    (this.$refs.Pmoneys as any).blur();
    this.priceFlage = false;
  }
  // << 止损价钱
  public handleMoneyCloseKey2() {
    (this.$refs.Lmoneys as any).blur();
    this.priceFlage2 = false;
  }

  @Watch('conditionNotTriggerList', {deep: true})
  public changeList(news, old) {
    this.popupFlage = true;
    this.getData();
  }
  @Watch('showFlage', { deep: true })
  public changeTarget(news, old) {
    if (news) {
      this.ChectData = front.subTick(this.tids, 'CheckFullStop');
      this.getData();
    } else {
      front.unsubTick(this.tids, 'CheckFullStop');
    }
  }
  @Watch('ChectData', {deep: true})
  public watchChectData(news, old) {
    this.newPrice = news.latestPrice;
  }
  public subTickData() {
    front.unsubTick(this.tids, 'CheckFullStop');
    this.ChectData = front.subTick(this.tids, 'CheckFullStop');
  }
  public activated() {
    this.getData();
    // 数据初始化
    this.showTxt = '当日';
    this.validity = [
      '当日',
      '永久',
    ];
    this.enterTxt = '增加条件单';
    this.listTitle = [
      '日期',
      '手数',
      '止损价',
      '止盈价',
      '状态',
      '有效期',
    ];
  }
  public getData() {
    const arr: any[] = [];
    this.hasNum = 0;
    for (const item of this.conditionNotTriggerList) {
      const lossPrice = Number(item.slPrice) === 0 ? '' : item.slPrice;
      const profitPrice = Number(item.tpPrice) === 0 ? '' : item.tpPrice;
      if ((item as any).orderType === 1 &&
        item.targetId === this.titles &&
        (item as any).posDirection === this.direction(this.datas.type)) {
        this.hasNum += Number((item as any).volume);
        arr.push({
          date: (item as any).insertDate ?
              (item as any).insertDate + ' '
              + (item as any).insertTime.substring(0, 8) :
              (item as any).updateDate + ' '
              + (item as any).updateTime.substring(0, 8),
          num: (item as any).volume,
          lossPrice,
          profitPrice,
          type: item.state === front.con_order_run ?
            '启动' : '暂停',
          effective: conditionData.getText(conditionData.validTime,
          item.validTime),
          conditionPriceType: (item as any).conditionPriceType,
          direction: (item as any).direction,
          id: (item as any).id,
          offset: (item as any).offset,
          operationType: (item as any).operationType,
          orderPrice: (item as any).orderPrice,
          orderPriceType: (item as any).orderPriceType,
          orderType: (item as any).orderType,
          posDirection: (item as any).posDirection,
          state: (item as any).state,
          targetId: (item as any).targetId,
          validTime: (item as any).validTime,
          buttonTxt: item.state === front.con_order_run ?
            '暂停' : '启动',
        });
      }
    }
    this.listData = arr;
  }
  // 添加修改
  public addEdit(item: any = '') {
    if (Number(this.lossNum) === 0) {
      this.openFeedbackToast('请输入止盈止损单数量', 'error', 2400);
      return;
    }
    const nums = this.hasNum - this.thisNum;
    if (this.positions < (Number(this.lossNum) + nums)) {
      this.openFeedbackToast('止盈止损单总数量大于持仓数量', 'error', 2400);
      return;
    }
    if (this.lossPrice === '' || Number(this.lossPrice) === 0) {
      if (this.profitPrice === '' || Number(this.profitPrice) === 0) {
        this.openFeedbackToast('请至少填写止盈价或止损价', 'error', 2400);
        return;
      }
    }
    if (((this.lossPrice * 100000000) as any).toFixed(0) % ((this.priceTicks * 100000000)as any).toFixed(0) !== 0) {
      this.openFeedbackToast('止盈价格不符合该合约的最小变动价', 'error', 2400);
      return;
    }
    if (((this.profitPrice * 100000000) as any).toFixed(0) % ((this.priceTicks * 100000000) as any).toFixed(0) !== 0) {
      this.openFeedbackToast('止损价格不符合该合约的最小变动价', 'error', 2400);
      return;
    }
    const cond = new ctpfront_pb.OrderConditional();
    cond.setTargetId(this.titles);
    cond.setVolume(this.lossNum);
    cond.setSlPrice(this.lossPrice);
    cond.setTpPrice(this.profitPrice);
    cond.setOrderType(1);   // 1,  普通 0
    cond.setValidTime(Number(this.period));    // 当日 0  永久 1
    cond.setOrderPriceType(17);      // 价格类型: 市价
    if (item) {
      cond.setId(item.id);
      cond.setPosDirection(item.posDirection);   // 买多 1 卖空 2
      cond.setState(item.state);
      cond.setOffset(item.offset);
      cond.setDirection(item.direction);   // 买多 1 卖空 2
    } else {
      let num = 0;
      for (const items of this.listData) {
        num += items.num;
      }
      if (num >= this.positions) {
        this.openFeedbackToast('止盈止损单总数量大于持仓数量', 'error', 2400);
        return;
      }
      cond.setPosDirection(this.direction(this.datas.type));   // 买多 1 卖空 2
    }
    front.conditionOrderSave(cond, resolve => {
      utils.closeIndicator();
      this.openFeedbackToast('添加云条件单成功', 'success');
      if(process.env.NODE_ENV === 'development')
        console.log(resolve);
      this.handleClose(true);
      this.thisNum = 0;
    }, reject => {
      console.error(reject);
      this.openFeedbackToast('添加云条件单失败: ' + reject.message, 'error', 2600);
      utils.closeIndicator();
    });
  }
  // 暂停
  public handleStopOrder(item) {
    if(process.env.NODE_ENV === 'development')
      console.log(item);
    // 暂停.
    const cond = new ctpfront_pb.OrderConditional();
    cond.setId(item.id);
    cond.setTargetId(item.targetId);
    cond.setVolume(item.num);
    cond.setSlPrice(item.lossPrice);
    cond.setTpPrice(item.profitPrice);
    cond.setConditionPriceType(front.con_last_price);
    cond.setOperationType(item.operationType);
    cond.setPosDirection(item.posDirection);
    cond.setOffset(item.offset);
    cond.setValidTime(item.validTime);
    cond.setOrderPriceType(17);      // 价格类型: 市价
    // cond.setOrderPrice(item.orderPrice);
    // cond.setOrderPriceType(item.orderPriceType);
    cond.setOrderType(1);   // 1,  普通 0

    if (item.state === front.con_order_run) {
      cond.setState(front.con_order_stop);
    } else {
      cond.setState(front.con_order_run);
    }

    utils.indicator('正在处理');
    front.conditionOrderSave(cond, resolve => {
      utils.closeIndicator();
      this.openFeedbackToast('止盈止损单操作成功', 'success', 2200);
      if(process.env.NODE_ENV === 'development')
        console.log(resolve);
    }, reject => {
      console.error(reject);
      this.openFeedbackToast('止盈止损单操作失败: ' + reject.message, 'error', 2600);
      utils.closeIndicator();
    });
  }
  // 删除
  public async handleDeleOrder(item: IOrderConditional) {

    try {
      await utils.confirm('确认删除吗',
        '删除',
        '确定',
        '取消');
    } catch (e) {
      console.log(e);
      return;
    }

    utils.indicator('正在处理....');
    front.conditionOrderRemove('', '',
      item.id, resolve => {
        utils.closeIndicator();
        this.openFeedbackToast('删除止盈止损单成功', 'success', 2200);
      }, reject => {
        this.openFeedbackToast('删除止盈止损单失败: ' + reject.message, 'error', 2600);
        utils.closeIndicator();
      });
  }

  public beforeDestroy() {
    if (this.feedbackTimer) {
      clearTimeout(this.feedbackTimer);
      this.feedbackTimer = null;
    }
  }
  // 修改
  public handleEditOrder(item) {
    this.enterTxt = '修改';
    this.handleClose(false, { lossPrice: item.lossPrice,
                              profitPrice: item.profitPrice,
                              num: item.num,
                              validTime: item.validTime});

    this.itemData = item;
    this.thisNum = item.num;
    // 修改
  }
  // 查看日志
  // public handleLogMsg(item) {
  //   // console.log(item.id);
  //   this.logFlage = true;
  //   this.$store.commit('market/showLogPage', true);
  //   const ars = new ctpfront_pb.ConditionOrderRecordGetReq();
  //   ars.setConId(item.id);
  //   const arr: any = [];
  //   front.conditionOrderLogo(ars, resolve => {
  //     // console.log(resolve);
  //     arr.push({
  //       targetId: this.titles,
  //       ID: resolve.conId,
  //       optionType: this.optionType(resolve.operation),
  //       runState: resolve.state === 1 ?
  //         '运行中' : '暂停',
  //       computedMac: resolve.updateip,
  //       optionTime: resolve.datetime,
  //       describe: resolve.description,
  //     });
  //     this.logoDataList = arr;
  //   }, reject => {
  //     console.log(reject);
  //   });
  // }
  // // 日志操作类型
  // public optionType(index) {
  //   switch (index) {
  //     case 0:
  //       return '增加条件单';
  //     case 1:
  //       return '修改';
  //     case 2:
  //       return '删除';
  //     default:
  //       break;
  //   }
  // }
  // 关闭日志列表
  // public handleCloseLog() {
  //   this.logFlage = false;
  // }
  // 选择有效期
  public handleSelectOption() {
    this.validityFlage = !this.validityFlage;
  }
  public handleSelectValidity(item, index) {
    this.validityFlage = false;
    this.period = index;
    this.showTxt = item;
  }
  // 滚动阻止
  // public handleTouchstartWarp(e) {
  //   // e.stopPropagation();
  //   this.endClick = false;
  // }
  // public handleScroll(e) {
  //   e.stopPropagation();
  //   this.endClick = true;
  // }
}



// WEBPACK FOOTER //
// ./src/views/TradeDetail/components/CheckFullStop/CheckFullStop.ts